import { LOCATION_CHANGE, matchPath } from 'connected-react-router';
import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import { initialState, addItemToData } from '../../utils/redux/commonActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';

// CREW-1240 — the employee card's "Vacancy ad contact for owners" block: the
// same `vacancy_contacts` rows the owner tab shows, read from the other side.
export const constants = getConstantsByFeatureName('CREW_USER_VACANCY_CONTACTS');
export const actions = getActionCreators(constants);
export const reducer = buildReducer(initialState, {
  ...getActionHandlers(constants),
  [LOCATION_CHANGE]: (state, { payload: { location: { pathname } } }) => (
    matchPath(pathname, { path: '/crew-users/:id/details' })
      ? state
      : initialState
  ),
  [constants.ADD_CREATED_ITEM]: (state, action) => {
    const newState = addItemToData(state, action);

    return { ...newState, data: [...newState.data].sort((a, b) => String(a.name).localeCompare(String(b.name))) };
  },
});
export const selector = getSelectorByFeatureName('crewUserVacancyContacts');
